import { useMemo } from "react";
import { Pressable, Text, View } from "react-native";
import LoadingSpinner from "ui/atoms/spinner/LoadingSpinner";

export interface CellListColumnModel<T> {
  title?: string;
  key: string;
  hide?: boolean;
  className?: string;
  renderData?: (item: T) => JSX.Element | null;
}

interface Props<T> {
  columns: CellListColumnModel<T>[];
  data: T[];
  identifierKey?: string;
  cellBackgroundColor?: ((item: T) => string) | string;
  noDataMessage?: string | React.ReactNode;
  isFetching?: boolean;
  onRowPress?: (item: T) => void;
  className?: string;
}

export function CellsList<T>(props: Props<T>) {
  const columns = useMemo(
    () => props.columns.filter((item) => !item.hide),
    [props.columns],
  );
  return (
    <table className="w-full">
      <thead>
        <tr>
          {columns.map((column) => (
            <th className={`text-left text-sm text-gray-500 font-medium px-2 first:pl-4 last:pr-4 pb-4 capitalize ${column.className ?? ""}`}>
              {column.title === "Preparation needed" ? (
                <>
                  Preparation <br /> needed
                </>
              ) : (
                column.title
              )}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {props.data.map((item) => {
          const cellBackgroundColor =
            typeof props.cellBackgroundColor === "function"
              ? props.cellBackgroundColor(item)
              : (props.cellBackgroundColor ?? "");
          return (
            <>
              <tr
                key={item[props.identifierKey || "id"]}
                className={`${cellBackgroundColor}`}
              >
                {columns.map((column) => (
                  <td
                    className={`first:rounded-l-lg last:rounded-r-lg transition first:pl-2 last:pr-2 ${column.className ?? ""}`}
                  >
                    <Pressable
                      className={`px-2 py-2 min-h-16 justify-center ${props.className} ${
                        props.onRowPress ? "cursor-pointer" : "cursor-default"
                      }`}
                      onPress={
                        props.onRowPress ? () => props.onRowPress(item) : null
                      }
                    >
                      <View>
                        {column.renderData ? (
                          column.renderData(item)
                        ) : (
                          <View className="max-w-64">
                            <Text>{String(item[column.key])}</Text>
                          </View>
                        )}
                      </View>
                    </Pressable>
                  </td>
                ))}
              </tr>
              <tr>
                <td className="h-3 "></td>
              </tr>
            </>
          );
        })}

        {!props.data?.length ? (
          props.isFetching ? (
            <LoadingSpinner />
          ) : (
            <tr>
              <td colSpan={columns.length} className="text-center ">
                {props.noDataMessage || "No data"}
              </td>
            </tr>
          )
        ) : null}
      </tbody>
    </table>
  );
}
